export default "__VITE_ASSET__CjIGzXBe__"